module.exports = __webpack_public_path__ + "static/media/intro.11a8b72c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Brief/img/intro.jpg
// module id = 499
// module chunks = 0